import {
  useStripe,
  useElements,
  CardElement,
  PaymentElement,
} from "@stripe/react-stripe-js";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { CheckBoxData, countryData } from "../../utils/UserDataCheckBox";
import { IoMdClose } from "react-icons/io";
import {
  addSpace,
  confirmPayment,
  payment,
  paymentToggle,
  viewSpaceDetails,
} from "../../services/ApiServices";
import toast from "react-hot-toast";
import { isEditable } from "@testing-library/user-event/dist/utils";
import { useNavigate } from "react-router-dom";
import Autocomplete from "react-google-autocomplete";

const AddSpaceForm = ({ spaceItem, orderAmount, clientSecret }: any) => {
  // console.log("spaceItem", spaceItem);

  const userProfileString = localStorage?.getItem("userProfile");
  const userDetail: any = userProfileString
    ? JSON.parse(userProfileString)
    : null;
  const [isLoading, setLoading] = useState<boolean>(false);
  const [propertyType, setPropertyType] = useState<any>();
  const [isLease, setLease] = useState<any>({ value: "1", label: "For Lease" });
  const [sqftPrice, setSQFTPrice] = useState<string>();
  const [monthlyRent, setMonthlyRent] = useState<string>();
  const [priceForSale, setPriceOfSale] = useState<string>();
  const [disOfPropery, setDesOfProperty] = useState<string>();
  const [discription, setDiscription] = useState<string>();
  const [continent, setContinent] = useState<any>();
  const [country, setCountry] = useState<any>();
  const [city, setCity] = useState<any>();
  const [state, setState] = useState<any>();
  const [address, setAddress] = useState<any>();
  const [suite, setSuite] = useState<string>();
  const [adCode, setADCode] = useState<string>();
  const [propertyImage, setPropertyImage] = useState<any>([]);
  const [propertyImageList, setPropertyImageList] = useState<any[]>([]);
  const [payments, setPayments] = useState(true);
  const [intent, setIntent] = useState("");
  const [ephermal, setEphermal] = useState("");
  const [customer, setCustormer] = useState("");
  const [intentId, setIntentId] = useState("");
  const [openPaymentWarn, setOpenPaymentWarn] = useState<boolean>(false);
  const [openstripeModal, setOpenStripeModal] = useState<boolean>(false);
  const [isProcessing, setProcessing] = useState<boolean>(false);
  const [coordinates, setCoordinates] = useState<any>({ lat: null, lng: null });
  const [isOpenSuccessModal, setOpenSuccessModal] = useState<boolean>(false);
  const [deletedImage, setDeletedImage] = useState<any[]>([]);
  console.log("propertyImage........", propertyImage, propertyImageList);
  console.log("deletedImage", deletedImage);

  console.log("address", address);

  useEffect(() => {
    if (spaceItem) {
      viewSpaceDetails(spaceItem?.id)
        .then((res) => {
          // console.log("spaceDetails res", res);
          const spaceDetail: any = res?.space_detail;
          setPropertyType({
            value: spaceDetail?.property_type,
            label: spaceDetail?.property_type,
          });
          setLease(
            spaceDetail?.monthly_rent
              ? { value: "1", label: "For Lease" }
              : { value: "0", label: "For Sale" }
          );
          setSQFTPrice(spaceDetail?.square_feet);
          setMonthlyRent(spaceDetail?.monthly_rent);
          setPriceOfSale(spaceDetail?.price);
          setDesOfProperty(spaceDetail?.space_description);
          setDiscription(spaceDetail?.description);
          setAddress({
            value: { description: spaceDetail?.address },
            label: spaceDetail?.address,
          });
          setPropertyImage(spaceDetail?.images);
          setPropertyImageList(spaceDetail?.images);
          setSuite(spaceDetail?.suite);
        })
        .catch((err) => {
          console.log("space details error", err);
        });
      // setPropertyType({ value: spaceItem?.property_type, label: spaceItem?.property_type })
      // setLease(spaceItem?.monthly_rent ? { value: "1", label: "For Lease" } : { value: "0", label: "For Sale" });
      // setSQFTPrice(spaceItem?.square_feet);
      // setMonthlyRent(spaceItem?.monthly_rent);
      // setPriceOfSale(spaceItem?.price_per_square)
      // setDesOfProperty(spaceItem?.space_description);
      // setDiscription(spaceItem?.description);
      // setAddress({ value: { description: spaceItem?.address, }, label: spaceItem?.address })
      // setPropertyImageList(spaceItem?.images)
    }
  }, []);

  useEffect(() => {
    paymentToggle()
      .then((res) => {
        // console.log("payment response", res);
        if (res.status === "success") {
          setPayments(true);
        } else {
          setPayments(false);
        }
      })
      .catch((err) => {
        // console.log("payment error", err);
        setPayments(false);
      });
    fetchPaymentSheetParams();
  }, []);

  const fetchPaymentSheetParams = async () => {
    payment(userDetail?.api_token)
      .then((res) => {
        // console.log("payment success", res);
        const { paymentIntent, ephemeralKey, customer } = res;
        setIntent(res.paymentIntent);
        setEphermal(res.ephemeralKey);
        setCustormer(res.customer);
        setIntentId(res.payment_intent_id);
        // setOrderAmount(res.order_amount)
        return paymentIntent;
      })
      .catch((err) => {
        // console.log("payment error", err);
      });
  };

  const status = [
    { value: "1", label: "For Lease" },
    { value: "0", label: "For Sale" },
  ];

  const handleUploadImageChange = (event: any) => {
    // console.log("event", event?.target?.files);
    const fileObj =
      event.target.files && URL.createObjectURL(event.target.files[0]);
    if (!fileObj) {
      return;
    } else {
      setPropertyImage([...propertyImage, fileObj]);
      setPropertyImageList([...propertyImageList, event?.target?.files[0]]);
      event.target.value = null;
    }
  };

  const removeImage = (item: any, id: any) => {
    setPropertyImage(
      propertyImage?.filter((image: any, index: number) => index !== id)
    );
    setPropertyImageList(
      propertyImageList?.filter((image: any, index: number) => index !== id)
    );
    setDeletedImage([
      ...deletedImage,
      item
    ])
  };

  const stripe: any = useStripe();
  const elements: any = useElements();
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState(null);
  // console.log("clientSecret", stripe);

  // const handleSubmit = async (event: any) => {
  //     event.preventDefault();
  //     console.log("elements", elements);

  //     if (!stripe && !elements) {
  //         console.log("return from stripe");

  //         return;
  //     }

  //     // Trigger form validation and wallet collection
  //     const { error: submitError } = await elements.submit();
  //     console.log("submitError", submitError);

  //     if (submitError) {
  //         // Show error to your customer
  //         setErrorMessage(submitError.message);
  //         return;
  //     }

  //     const { error, paymentIntent } = await stripe.confirmPayment({
  //         elements,
  //         amount: orderAmount,
  //         automatic_payment_methods: {
  //             enabled: true,
  //         },
  //         payment_method: {
  //             card: elements.getElement(CardElement),
  //             billing_details: {
  //                 name: "Merchant Name",
  //             },
  //         },
  //         clientSecret: intent,
  //         confirmParams: {
  //             return_url: 'https://example.com/order/123/complete',
  //         },
  //     });

  //     if (error) {
  //         setErrorMessage(error.message);
  //         console.log("payment errorrrrr", error.message);

  //     } else {
  //         console.log('Payment succeeded:', paymentIntent);
  //     }
  // };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    if (!stripe || !elements) {
      // Stripe.js hasn't yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {},
      redirect: "if_required",
    });

    // This point will only be reached if there is an immediate error when
    // confirming the payment. Otherwise, your customer will be redirected to
    // your `return_url`. For some payment methods like iDEAL, your customer will
    // be redirected to an intermediate site first to authorize the payment, then
    // redirected to the `return_url`.
    if (error) {
      console.log("carderror", error);
      setLoading(false);
      toast.error(error?.message);
    } else {
      // console.log("dsfdsf");
      confirmPayment({
        payment_intent_id: intentId,
        customer_id: customer,
      })
        .then((res) => {
          setLoading(false);
          if (res?.status === "success") {
            setOpenStripeModal(false);
            addSpaceAPICall();
          } else {
            setLoading(false);
            console.log("confirm payment error");
          }
        })
        .catch((err) => {
          setLoading(false);
          console.log("confirm payment error=======>", err);
        });
      // setMessage("An unexpected error occurred.");
    }
  };

  // const handleSubmit = async (event: any) => {
  //     event.preventDefault();

  //     if (!stripe || !elements) {
  //         console.log("stripe", stripe, elements);
  //         return;
  //     }
  //     const card = elements.getElement(CardElement);
  //     console.log("cardcard", card);

  //     if (card == null) {
  //         return;
  //     }

  //     // Use your card Element with other Stripe.js APIs
  //     // const { error, paymentMethod } = await stripe.createPaymentMethod({
  //     //     type: 'card',
  //     //     card,
  //     // });

  //     const { error, paymentIntent } = await stripe.confirmCardPayment(intent, {
  //         payment_method: {
  //             card: card,
  //         },
  //     });
  //     if (error) {
  //         console.log('[error]', error);
  //     } else {
  //         console.log('[PaymentMethod]', paymentIntent);
  //         confirmPayment({
  //             payment_intent_id: intentId,
  //             customer_id: customer
  //         }).then((res) => {
  //             if (res.status === "success") {
  //                 setOpenStripeModal(false)
  //                 addSpaceAPICall()
  //             } else {
  //                 console.log("confirm payment error");
  //             }
  //         }).catch((err) => {
  //             console.log("confirm payment error=======>", err);
  //         });
  //     }
  // };

  const handlePostProperty = () => {
    if (!propertyType && !disOfPropery) {
      toast.error("Please select property type or describe your Property");
      return;
    }
    if (isLease?.value === "1" && !monthlyRent) {
      toast.error("Please enter monthly rent");
      return;
    }
    if (isLease?.value === "0" && !priceForSale) {
      toast.error("Please enter selling price");
      return;
    }
    if (!sqftPrice) {
      toast.error("Please enter square feet");
      return;
    }
    if (!spaceItem && !country) {
      toast.error("Please select continent");
      return;
    }
    if (!address) {
      toast.error("Please enter address");
      return;
    }
    if (propertyImage?.length === 0) {
      toast.error("Add At Least One Picture of Property");
      return;
    }
    if (propertyImage && propertyImage?.length > 15) {
      toast.error("Maximum 15 photos allowed");
      return;
    }
    if (orderAmount >= 0.5 && !adCode && !spaceItem) {
      // console.log("dfgfg");
      setOpenPaymentWarn(true);
      // addSpaceAPICall();

    } else if (adCode || spaceItem) {
      console.log("edit property call");
      addSpaceAPICall();
    } else {
      console.log("success");
      addSpaceAPICall();
    }
  };

  const addSpaceAPICall = () => {
    setProcessing(true);
    const deletedData: any = deletedImage?.map((item: any) => item?.id)
    console.log("deletedData", deletedData);

    const data = new FormData();
    propertyImageList?.map((image, index) => {
      if (!image?.image) {
        return data.append("images[]", image);
      }
    });
    // deletedImage.forEach(item => {
    //   data.append("delete_image", item.image);
    // });
    if (deletedData?.length > 0) {
      data.append("delete_image[]", deletedData)
    }
    // Handle property_type logic
    if (propertyType) {
      if (propertyType.value === "Other Space" && disOfPropery) {
        data.append("property_type", disOfPropery); // Use custom description for "Other Space"
      } else {
        data.append("property_type", propertyType.value); // Use selected property type
      }
    }
    if (isLease?.value === "1") {
      data.append("is_lease", "1");
      data.append("monthly_rent", monthlyRent ? monthlyRent : "");
    }
    if (isLease?.value === "0") {
      data.append("is_sale", "1");
      data.append("price", priceForSale ? priceForSale : "");
    }
    // if (disOfPropery) {
    //   data.append("property_type", disOfPropery);
    // }
    if (spaceItem) {
      data.append("space_id", spaceItem.id);
    }
    if (sqftPrice) {
      data.append("square_feet", sqftPrice ? sqftPrice : "");
    }
    if (continent) {
      data.append("continent", continent ? continent?.value : "");
    }
    if (address) {
      data.append("address", address?.formatted_address ? address?.formatted_address : address?.value?.description);
    }
    if (suite) {
      data.append("suite", suite ? suite : "");
    }
    if (adCode) {
      data.append("promocode", adCode ? adCode : "");
    }
    if (coordinates?.lat) {
      data.append("latitude", coordinates?.lat);
    }
    if (coordinates?.lng) {
      data.append("longitude", coordinates?.lng);
    }
    if (discription) {
      data.append("space_description", discription);
    }
    data.append("country", country ? country : "");
    data.append("state", state ? state : "");
    data.append("city", city ? city : "");
    console.log('data', data)
    addSpace(data)
      .then((res) => {
        // console.log("addSpaceAPICall", res);
        // console.log("$$$$$$$$$$$$$$data...", data);

        // setOpenSuccessModal(true) // Check if the status is 'error' or 'success'
        if (res?.status === "error") {
          // Show error toast message if status is 'error'
          toast.error(res?.message);
        } else if (res?.status === "success") {
          // Show success toast and open the modal if status is 'success'
          toast.success(res?.message);
          setOpenSuccessModal(true);
        }
        setProcessing(false);
        // navigate("/my-space")
      })
      .catch((err) => {
        console.log("add space error", err);
      });
  };

  const handleSelect = async (place: any) => {
    if (!place) return;

    const service = new window.google.maps.places.PlacesService(
      document.createElement("div")
    );

    // Fetch place details using place_id
    service.getDetails(
      { placeId: place.value.place_id },
      (result: any, status) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK) {
          const lat = result.geometry.location.lat();
          const lng = result.geometry.location.lng();
          setCoordinates({ lat, lng });
          // console.log("Coordinates:", { lat, lng }, result);
        } else {
          console.error("Error fetching place details:", status);
        }
      }
    );
  };

  const appearance = {
    theme: "stripe",
    variables: {
      colorPrimary: "#0570de",
      colorBackground: "#ffffff",
      colorText: "#30313d",
      colorDanger: "#df1b41",
      fontFamily: "Ideal Sans, system-ui, sans-serif",
      spacingUnit: "2px",
      borderRadius: "4px",
    },
  };

  const paymentElementOptions = {
    layout: "accordion",
  };
  // const [value, setValue] = useState('');
  const [error, setError] = useState("");

  // const handleChange = (e: React.ChangeEvent<HTMLInputElement>, setValue: any) => {
  //     const inputValue = e.target.value;
  //     console.log("/^\d*$/.test(inputValue)", /^\d*$/.test(inputValue));

  //     // Check if the value is numeric
  //     if (/^\d*$/.test(inputValue)) {
  //         setValue(inputValue);
  //         setError('');
  //     } else {
  //         toast.error('Only numbers are allowed.')
  //     }
  // };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    setValue: any
  ) => {
    const inputValue = e.target.value;

    // Remove any non-numeric characters immediately
    const filteredValue = inputValue.replace(/\D/g, "");

    if (filteredValue !== inputValue) {
      toast.error("Only numbers are allowed.");
      // setError('Only numbers are allowed.');
    } else {
      setError("");
    }

    setValue(filteredValue); // Always set only the valid numeric part
  };

  const getPlaceDetails = (placeId: any) => {
    return new Promise((resolve, reject) => {
      const service = new window.google.maps.places.PlacesService(document.createElement("div"));

      service.getDetails(
        { placeId, fields: ["address_components", "formatted_address"] },
        (place: any, status) => {
          if (status === window.google.maps.places.PlacesServiceStatus.OK) {
            const components: any = place.address_components;

            const city = components.find((c: any) => c.types.includes("locality"))?.long_name || "";
            const state = components.find((c: any) => c.types.includes("administrative_area_level_1"))?.long_name || "";
            const country = components.find((c: any) => c.types.includes("country"))?.long_name || "";

            resolve({ city, state, country });
          } else {
            reject(status);
          }
        }
      );
    });
  };

  return (
    <>
      {/* <form onSubmit={handleSubmit}>
                <PaymentElement />
                <button type="submit" disabled={!stripe || !elements}>
                    Pay
                </button>
                {errorMessage && <div>{errorMessage}</div>}
            </form> */}
      <form>
        {/* <PaymentElement /> */}
        <div className="row">
          <div className="submit-page">
            <div className="col-lg-12 col-md-12">
              <div className="form-submit">
                <h3>{spaceItem ? "Edit Property" : "Add Property"}</h3>
                <div className="submit-section">
                  <div className="row">
                    <div className="form-group col-md-12">
                      <label className="mb-2">Property Type</label>
                      <Select
                        options={CheckBoxData}
                        className="form-control"
                        placeholder="Select Property Type"
                        onChange={(e: any) => setPropertyType(e)}
                        value={propertyType}
                        // isDisabled={spaceItem ? true : false}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 1000 }),
                          menu: (base) => ({
                            ...base,
                            position: "absolute",
                            zIndex: 1000, // Ensures dropdown is below the header
                          }),
                        }}
                        menuPortalTarget={document.body}
                      />
                    </div>
                    <div
                      className="form-group col-md-12"
                      style={{
                        display:
                          propertyType?.value !== "Other Space"
                            ? "none"
                            : "block",
                      }}
                    >
                      <label className="mb-2">
                        If Other please describe (Max length 25 characters)
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="If Other please describe property"
                        onChange={(e: any) => setDesOfProperty(e.target.value)}
                        value={disOfPropery}
                        disabled={propertyType?.value !== "Other Space"}
                        style={{
                          opacity:
                            propertyType?.value !== "Other Space" ? 0.5 : 1,
                        }}
                        maxLength={25}
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label className="mb-2">Status</label>
                      <Select
                        options={status}
                        className="form-control"
                        placeholder="Select Status"
                        onChange={(e: any) => setLease(e)}
                        value={isLease}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 1000 }),
                        }}
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label className="mb-2">square feet of space</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="square feet of space"
                        // onChange={(e: any) => setSQFTPrice(e.target.value)}
                        onChange={(e: any) => handleChange(e, setSQFTPrice)}
                        value={sqftPrice}
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label className="mb-2">Total Monthly Rent</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Total Monthly rent"
                        // onChange={(e: any) => setMonthlyRent(e.target.value)}
                        onChange={(e: any) => handleChange(e, setMonthlyRent)}
                        value={monthlyRent}
                        style={{ opacity: isLease?.value === "0" ? 0.5 : 1 }}
                        disabled={isLease?.value === "0" ? true : false}
                        maxLength={9}
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label className="mb-2">Price of Property For Sale</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Price of Property For Sale"
                        // onChange={(e: any) => setPriceOfSale(e.target.value)}
                        onChange={(e: any) => handleChange(e, setPriceOfSale)}
                        value={priceForSale}
                        style={{ opacity: isLease?.value === "1" ? 0.5 : 1 }}
                        disabled={isLease?.value === "1" ? true : false}
                      />
                    </div>

                    <div className="form-group  col-md-12">
                      <label className="mb-2">
                        Tell us About This space/property
                      </label>
                      <textarea
                        className="form-control"
                        placeholder="Tell us About This space/property"
                        onChange={(e: any) => setDiscription(e.target.value)}
                        value={discription}
                        maxLength={2000}
                      // disabled={propertyType?.value === "Other Space"}
                      // style={{ opacity: propertyType?.value === "Other Space" ? 0.5 : 1 }}
                      />
                    </div>
                    {!spaceItem && (
                      <div className="form-group col-md-6">
                        <label className="mb-2">Continent</label>
                        <Select
                          options={countryData}
                          className="form-control"
                          placeholder="Select Continent"
                          onChange={(e: any) => setContinent(e)}
                        // value={country}
                        />
                      </div>
                    )}
                    <div className="form-group col-md-6">
                      <label className="mb-2">Address</label>
                      {/* <GooglePlacesAutocomplete
                        apiKey="AIzaSyApsnfh0LcjwuVtDEEYVrzqCSw075qYEvg"
                        selectProps={{
                          value: address,
                          // onChange: setAddress,
                          onChange: async (place) => {
                            console.log("Selected Place:", place);

                            setAddress(place);

                            // Fetch lat/lng
                            if (place?.value?.place_id) {
                              const detail: any = await getPlaceDetails(place.value.place_id);
                              console.log("Coordinates:", detail);
                              setCountry(detail?.country);
                              setCity(detail?.city);
                              setState(detail?.state);
                            }
                          },
                          // onChange: (e, details) => {
                          //   console.log("details", details);

                          //   setAddress(e);
                          //   handleSelect(e);
                          // },
                          className: "form-control",
                        }}
                      /> */}
                      <Autocomplete
                        apiKey="AIzaSyApsnfh0LcjwuVtDEEYVrzqCSw075qYEvg"
                        onPlaceSelected={async (place) => {
                          console.log("Selected Place:", place);

                          setAddress(place);

                          // Fetch lat/lng
                          if (place?.place_id) {
                            const detail: any = await getPlaceDetails(place?.place_id);
                            console.log("Coordinates:", detail);
                            setCountry(detail?.country);
                            setCity(detail?.city);
                            setState(detail?.state);
                          }
                        }}
                        className="form-control"
                        options={{
                          types: ["geocode"]
                        }}
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label className="mb-2">Suite(Optional)</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Suite"
                        onChange={(e: any) => setSuite(e.target.value)}
                        value={suite}
                      />
                    </div>
                    {!spaceItem && (
                      <div className="form-group col-md-6">
                        <label className="mb-2">
                          Enter Free AD Code(Optional)
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="AD Code"
                          onChange={(e: any) => setADCode(e.target.value)}
                          value={adCode}
                        />
                      </div>
                    )}
                    <div className="form-group col-md-12">
                      <label>Add up to 15 Photos</label>
                      <div className="dropzone dz-clickable primary-dropzone position-relative">
                        <div className="position-relative w-100 ">
                          <div className="dz-default dz-message">
                            <i className="fa-solid fa-images"></i>
                            <span>Drag & Drop To Change Logo</span>
                          </div>
                          <input
                            type="file"
                            style={{
                              position: "absolute",
                              top: -80,
                              height: 185,
                              opacity: 0,
                            }}
                            accept=".png, .jpg,.jpeg"
                            onChange={(e) => {
                              if (propertyImage?.length >= 15) {
                                toast.error("You can add only 15 images");
                                return;
                              } else {
                                handleUploadImageChange(e);
                              }
                            }}
                            onClick={(e) => {
                              if (propertyImage?.length >= 15) {
                                e.preventDefault();
                                toast.error("You can add only 15 images");
                                return;
                              }
                            }}
                            id="companyCoverPhoto"
                            className="dz-message dz-default w-100"
                            multiple
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-group col-md-12">
                      {propertyImage.length > 0 && (
                        <div
                          className="property-image-wrapper d-flex"
                          style={{
                            display: "flex",
                            flexWrap: "wrap", // Allows wrapping to new rows
                            gap: "10px", // Space between items
                            justifyContent: "flex-start", // Align items in a row
                            // maxWidth: '1080px' // Adjust max width to fit 9 images
                          }}
                        >
                          {propertyImage?.map((image: any, index: number) => {
                            console.log("image===>", image?.image);

                            return (
                              <div
                                className="property-image-wrapper position-relative"
                                style={{ marginRight: 20 }}
                              >
                                <img
                                  src={image?.image ? image.image : image}
                                  // src={image}
                                  alt=""
                                  width={120}
                                  height={120}
                                />
                                <div
                                  onClick={() => {
                                    removeImage(image, index);
                                  }}
                                  style={{
                                    position: "absolute",
                                    left: 105,
                                    top: -4,
                                    backgroundColor: "red",
                                    width: 20,
                                    height: 20,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "#fff",
                                    borderRadius: 50,
                                    cursor: "pointer",
                                  }}
                                >
                                  <IoMdClose />
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                    <div className="form-group col-lg-12 col-md-12">
                      <button
                        className="btn btn-primary fw-medium px-5"
                        type="button"
                        disabled={isProcessing}
                        onClick={() => {
                          handlePostProperty();
                        }}
                      >
                        {spaceItem
                          ? "Edit Property"
                          : isProcessing
                            ? "Adding..."
                            : "Add Property"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      {openPaymentWarn && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "#0000008a" }}
        >
          <div
            className="modal-dialog modal-dialog-centered login-pop-form"
            role="document"
          >
            <div className="modal-content" id="registermodal">
              <span
                className="mod-close"
                onClick={() => setOpenPaymentWarn(!openPaymentWarn)}
              >
                <span className="svg-icon text-primary svg-icon-2hx">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      opacity="0.3"
                      x="2"
                      y="2"
                      width="20"
                      height="20"
                      rx="10"
                      fill="currentColor"
                    ></rect>
                    <rect
                      x="7"
                      y="15.3137"
                      width="12"
                      height="2"
                      rx="1"
                      transform="rotate(-45 7 15.3137)"
                      fill="currentColor"
                    ></rect>
                    <rect
                      x="8.41422"
                      y="7"
                      width="12"
                      height="2"
                      rx="1"
                      transform="rotate(45 8.41422 7)"
                      fill="currentColor"
                    ></rect>
                  </svg>
                </span>
              </span>
              <div className="modal-body">
                <h4 className="modal-header-title" style={{ fontSize: 25 }}>
                  All sales are final.
                </h4>
                <div className="d-flex align-items-center justify-content-center mb-3">
                  <span>
                    There will be no refunds Ad will expire in 45 days.
                  </span>
                </div>
                <div className="form-group d-flex">
                  <button
                    type="button"
                    className="btn btn-md btn-outline-primary fw-medium full-width rounded-2 me-2"
                    onClick={() => setOpenPaymentWarn(!openPaymentWarn)}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-md btn-primary fw-medium full-width rounded-2"
                    onClick={() => {
                      setOpenStripeModal(true);
                      setOpenPaymentWarn(false);
                    }}
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {openstripeModal && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "#0000008a" }}
        >
          <div
            className="modal-dialog modal-dialog-centered login-pop-form"
            role="document"
          >
            <div className="modal-content" id="registermodal">
              <span
                className="mod-close"
                onClick={() => setOpenStripeModal(!openstripeModal)}
              >
                <span className="svg-icon text-primary svg-icon-2hx">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      opacity="0.3"
                      x="2"
                      y="2"
                      width="20"
                      height="20"
                      rx="10"
                      fill="currentColor"
                    ></rect>
                    <rect
                      x="7"
                      y="15.3137"
                      width="12"
                      height="2"
                      rx="1"
                      transform="rotate(-45 7 15.3137)"
                      fill="currentColor"
                    ></rect>
                    <rect
                      x="8.41422"
                      y="7"
                      width="12"
                      height="2"
                      rx="1"
                      transform="rotate(45 8.41422 7)"
                      fill="currentColor"
                    ></rect>
                  </svg>
                </span>
              </span>
              <div className="modal-body">
                <form onSubmit={handleSubmit} id="payment-form">
                  <PaymentElement
                    id="payment-element"
                    options={{ layout: "tabs" }}
                  />
                  {/* <CardElement
                                    options={{}}
                                    /> */}
                  <button
                    id="submit"
                    className="btn btn-primary"
                    style={{
                      width: "100%",
                      marginTop: 10,
                      height: 40,
                      opacity: isLoading ? 0.5 : 1,
                    }}
                    disabled={isLoading}
                  >
                    <span id="button-text">
                      {isLoading ? "Paying..." : "Pay now"}
                    </span>
                  </button>
                  {/* <button type="submit" disabled={!stripe}>
                                        Pay
                                    </button> */}
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
      {isOpenSuccessModal && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "#0000008a" }}
        >
          <div
            className="modal-dialog modal-dialog-centered login-pop-form"
            role="document"
          >
            <div className="modal-content" id="registermodal">
              <span
                className="mod-close"
                onClick={() => setOpenSuccessModal(!isOpenSuccessModal)}
              >
                <span className="svg-icon text-primary svg-icon-2hx">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      opacity="0.3"
                      x="2"
                      y="2"
                      width="20"
                      height="20"
                      rx="10"
                      fill="currentColor"
                    ></rect>
                    <rect
                      x="7"
                      y="15.3137"
                      width="12"
                      height="2"
                      rx="1"
                      transform="rotate(-45 7 15.3137)"
                      fill="currentColor"
                    ></rect>
                    <rect
                      x="8.41422"
                      y="7"
                      width="12"
                      height="2"
                      rx="1"
                      transform="rotate(45 8.41422 7)"
                      fill="currentColor"
                    ></rect>
                  </svg>
                </span>
              </span>
              <div className="modal-body">
                <h4 className="modal-header-title" style={{ fontSize: 25 }}>
                  Success
                </h4>
                <div className="d-flex align-items-center justify-content-center mb-3">
                  <span>
                    Thank you for your Business! Your order is complete.
                  </span>
                </div>
                <div className="form-group d-flex">
                  <button
                    type="button"
                    className="btn btn-md btn-outline-primary fw-medium full-width rounded-2 me-2"
                    onClick={() => setOpenSuccessModal(!isOpenSuccessModal)}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-md btn-primary fw-medium full-width rounded-2"
                    onClick={() => {
                      setOpenSuccessModal(false);
                      navigate("/my-space");
                    }}
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AddSpaceForm;